import { graphql } from "react-relay";

export const nonUserDefragSurveyFragments = {
  viewer: graphql`
    fragment NonUserDefragSurvey_viewer on Viewer
    @argumentDefinitions(emailInstanceId: { type: "String!" }) {
      nonUserDefragEmailResponse(emailInstanceId: $emailInstanceId) {
        __typename
        ... on NonUserDefragEmailResponse {
          responseType
          additionalInformation
        }
      }
    }
  `,
};

export const nonUserDefragSurveyQuery = graphql`
  query NonUserDefragSurveyQuery($emailInstanceId: String!) {
    viewer {
      ...NonUserDefragSurvey_viewer @arguments(emailInstanceId: $emailInstanceId)
    }
  }
`;
